var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 739,
    viewBox: "0 0 750 739",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.046 18.6803C333.046 8.36346 324.683 0 314.366 0H51.8159C41.4991 0 33.1356 8.36347 33.1356 18.6803V20.7928C33.1356 29.943 25.7179 37.3606 16.5678 37.3606V37.3606C7.41765 37.3606 0 44.7783 0 53.9284V677.361C0 711.05 27.3106 738.361 61 738.361H689C722.689 738.361 750 711.05 750 677.361V98.3606C750 64.6713 722.689 37.3606 689 37.3606H351.726C341.41 37.3606 333.046 28.9972 333.046 18.6803V18.6803Z",
    fill: "#F9116C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBox);
export default __webpack_public_path__ + "static/media/right-box.ad9e860aeb0ff2305da53fb19647358e.svg";
export { ForwardRef as ReactComponent };